const targetNode = document.querySelector('#cart-drawer');

if (targetNode) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        console.log(123)
        BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
      }
    }
  });

  const config = {
    attributes: true,       
    attributeFilter: ['open'] 
  };

  observer.observe(targetNode, config);
}
